import React from 'react';
import {
  oneOfType, string, func, node, bool,
} from 'prop-types';
import FocusTrap from 'focus-trap-react';
import NavX from '../NavigationX';
import { ModalContainer, OuterContainer } from './UAMModalStyles';

const UAMModal = (props) => {
  const {
    role,
    onCancel,
    cancelDeactivatesModal,
    initialFocus,
    suppressHeader,
    headerContent,
    suppressFooter,
    footerContent,
    showCloseNav,
  } = props;
  const doc = document.documentElement;

  // remove scrolling on the rest of the page while modal is active
  const disableScroll = () => {
    doc.style.overflow = 'hidden';
  };

  // reinstate scrolling after the modal is completely deactivated
  const enableScroll = () => {
    doc.style.overflow = '';
  };

  const cancelWrap = (e) => {
    if (onCancel) {
      onCancel(e);
    }

    return cancelDeactivatesModal;
  };

  return (
    <FocusTrap
      focusTrapOptions={{
        onActivate: disableScroll,
        onDeactivate: cancelWrap,
        onPostDeactivate: enableScroll,
        escapeDeactivates: cancelWrap,
        clickOutsideDeactivates: cancelDeactivatesModal,
        initialFocus,
      }}
    >
      <OuterContainer>
        <ModalContainer onClick={(e) => e.stopPropagation()} aria-modal="true" role={role} className="modalContainer">
          {!suppressHeader && (
            <header className="headerContainer">
              <div className="headerContent">
                {headerContent}
              </div>

              {
                showCloseNav && (
                  <NavX id="closeButton" onClick={cancelWrap} title="Close" />
                )
              }

            </header>
          )}
          <main>{props.children}</main>
          {
            !suppressFooter && (
              <footer>{footerContent}</footer>
            )
          }
        </ModalContainer>
      </OuterContainer>
    </FocusTrap>
  );
};

UAMModal.propTypes = {
  size: string,
  headerContent: oneOfType([node, string]),
  footerContent: oneOfType([node, string]),
  onCancel: func,
  children: node.isRequired,
  role: string,
  cancelDeactivatesModal: bool,
  initialFocus: string,
  suppressHeader: bool,
  suppressFooter: bool,
  showCloseNav: bool,
};

UAMModal.defaultProps = {
  size: 'lg',
  headerContent: '',
  footerContent: '',
  onCancel: null,
  role: 'dialog',
  cancelDeactivatesModal: true,
  initialFocus: '#closeButton',
  suppressHeader: false,
  suppressFooter: false,
  showCloseNav: true,
};

export default UAMModal;
